module.exports = __webpack_public_path__ + "img/1-3.b10b84b4.jpg";